import React, { useRef, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import Sidebar from '../components/layout/Sidebar/index.js'
import MobileNav from '../components/layout/MobileNav'
import Header from '../components/layout/Header'
import UnpaidOrderBanner from '../components/common/UnpaidOrderBanner'
import { useUIStore } from '../stores/useUIStore'
import { useIsMobile } from '../hooks/useIsMobile'

const MainLayout = ({ children }) => {
  const { isSidebarOpen } = useUIStore()
  const location = useLocation()
  const scrollRef = useRef(null)
  const isMobile = useIsMobile()

  // Scroll to top on route change
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0
    }
  }, [location.pathname])

  const layoutTransition = {
    type: "spring",
    stiffness: 260,
    damping: 26,
    mass: 0.6,
    restDelta: 0.01
  }

  return (
    <div className="flex h-dvh bg-background overflow-hidden">
      {/* 侧边栏 — 仅桌面端渲染，移动端用底部 MobileNav */}
      {!isMobile && (
        <motion.div
          layout
          transition={layoutTransition}
          className="relative z-auto"
        >
          <Sidebar isOpen={isSidebarOpen} />
        </motion.div>
      )}

      {/* 移动端底部导航 — 仅移动端渲染 */}
      {isMobile && <MobileNav />}

      {/* 主内容区域 */}
      <motion.div
        layout
        transition={layoutTransition}
        className="flex-1 flex flex-col min-w-0 overflow-hidden"
      >
        {/* 头部导航 */}
        <div className="flex-shrink-0 relative z-30">
          <Header />
          <UnpaidOrderBanner />
        </div>

        {/* 主内容区 */}
        <main className="flex-1 relative overflow-hidden bg-background">
          <div
            ref={scrollRef}
            className="absolute inset-0 overflow-y-auto overflow-x-hidden"
            style={{
              WebkitOverflowScrolling: 'touch'
            }}
          >
            <div className="min-h-full">
              <div className="container mx-auto pl-[max(1rem,env(safe-area-inset-left))] pr-[max(1rem,env(safe-area-inset-right))] sm:px-6 lg:px-8 py-6 lg:py-8 pb-[calc(5rem+env(safe-area-inset-bottom))] lg:pb-8">
                <div className="max-w-7xl mx-auto">
                  {children}
                </div>
              </div>
            </div>
          </div>
        </main>
      </motion.div>
    </div>
  )
}

export default MainLayout
